/**
 * This Software is the property of dotfly and is protected
 * by copyright law - it is NOT Freeware.
 *
 * Any unauthorized use of this software without a valid license key
 * is a violation of the license agreement and will be prosecuted by
 * civil and criminal law.
 *
 * @category   Footer flapper
 * @author     Anna Morawe <anna.morawe@dotfly.de>
 * @license    http://www.dotfly.de Commercial
 * @link       http://www.dotfly.de
 */

const FooterFlapper = () => {

    let _oAccordion = document.querySelector('.c-flapper');

    function handlePanelClick(e){
        showPanel(e.currentTarget);
    }

    function showPanel(panel){
        let _oSelf = panel;
        let _oCurrentPanel = _oSelf.classList.contains('c-flapper--active');
        let _oContentPanel = _oSelf.nextElementSibling;
        let _oContentWrapPanel = _oContentPanel.firstElementChild;
        let _iContentHeight = _oContentWrapPanel.offsetHeight;

        // = Aria
        let _bIsAriaExp = _oSelf.getAttribute('aria-expanded');
        let _bNewAriaExp = (_bIsAriaExp === 'false') ? 'true' : 'false';

        _oSelf.setAttribute('aria-expanded', _bNewAriaExp);

        if(_oCurrentPanel) {
            _oSelf.classList.remove('c-flapper--active');
            _oContentPanel.style.height = 0;
            _oContentPanel.setAttribute('aria-hidden', 'true');
        }else {
            _oSelf.classList.add('c-flapper--active');
            _oContentPanel.style.height = _iContentHeight + 'px';
            _oContentPanel.setAttribute('aria-hidden', 'false');
        }
    }

    if(_oAccordion) {
        let _aAllPanelElems = _oAccordion.querySelectorAll('.js-footer-trigger');
        for (var i = 0, len = _aAllPanelElems.length; i < len; i++){
            _aAllPanelElems[i].addEventListener('click', handlePanelClick);
        }
    }

};

FooterFlapper();
